import { createMuiTheme } from "@material-ui/core";

export default createMuiTheme({
  palette: { primary: { main: "#004f83" }, secondary: { main: "#e11b23" } },
});
